import { redirect } from 'react-router-dom';
import { ME_QUERY } from '../gql/user';
import { getClient } from '../lib/apollo';
import { LOGIN, ACCEPT_TERMS, DASHBOARD } from '../../customers/src/routes';

export const registerLoader = async () => {
  try {
    const client = getClient();
    const { data } = await client.query({
      query: ME_QUERY,
      fetchPolicy: 'cache-first',
      errorPolicy: 'ignore',
    });

    const user = data?.me;

    if (!user) {
      throw redirect(LOGIN);
    }

    if (!user.termsAccepted) {
      throw redirect(ACCEPT_TERMS);
    }

    if (user.profileUpdated) {
      throw redirect(DASHBOARD);
    }

    return { user };
  } catch (error) {
    if (error && typeof error === 'object' && 'status' in error) {
      throw error;
    }

    throw redirect(LOGIN);
  }
};
